import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'qmLink'
})
export class QmLinkPipe implements PipeTransform {
  transform(value: string): string {
    return this.toLink(value);
  }

  private toLink(plainText): string{
    let replacedText;
    let replacePattern1;
    let replacePattern2;
    let replacePattern3;

    // URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = plainText.replace(replacePattern1, '&nbsp;<a href="$1" target="_blank">$1</a>&nbsp;');

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '&nbsp;$1<a href="http://$2" target="_blank">$2</a>&nbsp;');

    // Change email addresses to mailto:: links.
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '&nbsp;<a href="mailto:$1">$1</a>&nbsp;');

    return replacedText;
  }


}
